import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';
import { trackingConstants } from '@frontend/sports/tracking/feature';

export interface IReBetPicksPayload {
    winGameFixtures: WinGameFixture[];
    xCastFixtures: WinGameFixture[];
    fixtures: GridEvent[];
}

export interface TrackReBet {
    [trackingConstants.COMPONENT_CATEGORY_EVENT]: string;
    [trackingConstants.COMPONENT_LABEL_EVENT]: string;
    [trackingConstants.COMPONENT_ACTION_EVENT]: string;
    [trackingConstants.COMPONENT_POSITION_EVENT]: string;
    [trackingConstants.COMPONENT_LOCATION_EVENT]: string;
    [trackingConstants.COMPONENT_EVENT_DETAILS]: string;
    [trackingConstants.COMPONENT_URL_CLICKED]: string;
}

export enum ReBetTracking {
    MyAccount = 'my account',
    MyBets = 'my bets',
    Load = 'load',
    Click = 'click',
    SettledTab = 'settled',
    OpenTab = 'open',
    LiveTab = 'live',
    ReBetButton = 'rebet button',
    NotApplicable = 'not applicable',
}

export interface UkFraction {
    denominator: number;
    numerator: number;
}

export interface AllFormatsOdds {
    european?: number;
    british?: UkFraction;
    american?: number;
    oddsFormat: OddsUserFormat;
}

export enum OddsUserFormat {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    EU = 'european',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UK = 'british',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    US = 'american',
}

export enum TaxationModel {
    NotRelevant = 0,
    OnStake = 1,
    OnWinnings = 2,
}

export interface TaxationResponseRaw {
    taxations: TaxationResponse[];
}

export interface TaxationResponse {
    key: number;
    taxModel: TaxationModel;
    taxRateId: number;
    value: number;
}
